import * as React from 'react';
import { FC } from 'react';

import { ISanityImage } from '@rbi-ctg/menu';
import { ActionButtonVariants } from 'components/action-button';

import {
  ButtonWrapper,
  Container,
  DescriptionTextBlock,
  DesktopBar,
  FullPageImage,
  HeadingText,
  ImageContainer,
  LogoContainer,
  StyledButton,
  TitleText,
} from './empty-state.styled';
import { IEmptyStateProps } from './types';

const EmptyState: FC<IEmptyStateProps> = ({
  actionVariant = ActionButtonVariants.PRIMARY,
  content: { logo, backgroundImage, image, headerText, title, description, buttonAction },
  showCTA = false,
  titleFontColor = Styles.color.black,
}) => {
  const logoImage = logo?.locale?.app;
  const mainImage = image?.locale?.app;
  const header = headerText?.locale;
  const titleText = title?.locale;
  const descriptionContent = description?.locale;

  if (showCTA) {
    const bgImage = backgroundImage?.image as ISanityImage;

    return (
      <Container>
        {bgImage && <FullPageImage image={bgImage} alt="full-page-cover" />}
        <DesktopBar>
          {buttonAction?.actionText && (
            <StyledButton
              to={buttonAction.actionUrl?.locale || ''}
              variant={ActionButtonVariants.PRIMARY}
            >
              {buttonAction.actionText.locale}
            </StyledButton>
          )}
        </DesktopBar>
      </Container>
    );
  }

  return (
    <Container>
      {logoImage && <LogoContainer image={logoImage} alt={'logo'} objectFitContain />}
      {header && <HeadingText>{header}</HeadingText>}
      {mainImage && (
        <ImageContainer
          image={mainImage}
          alt={image?.locale?.imageDescription || 'Empty Image'}
          objectFitContain
        />
      )}
      {titleText && <TitleText $fontColor={titleFontColor}>{titleText}</TitleText>}
      {descriptionContent && <DescriptionTextBlock content={descriptionContent} />}
      {buttonAction?.actionText && (
        <ButtonWrapper>
          <StyledButton to={buttonAction.actionUrl?.locale || ''} variant={actionVariant}>
            {buttonAction.actionText.locale}
          </StyledButton>
        </ButtonWrapper>
      )}
    </Container>
  );
};

export default EmptyState;
